export default __webpack_public_path__ + "static/media/alphasignLogo.78d3533f.png";